import throttle from "./throttle";
var install = function install(Vue) {
  Vue.directive('throttle', throttle);
};
if (window.Vue) {
  window.throttle = throttle;
  Vue.use(throttle); // eslint-disable-line
}
throttle.install = install;
export default throttle;